import { CSSProperties, ReactNode } from "react";
import { ConfirmationModal } from "./ConfirmationModal";
import { ParameterRange } from "../models/range.model";
import { Table } from "reactstrap";

interface ScenarioType {
  [key: string]: number;
}

interface RangeType {
  [key: string]: ParameterRange;
}

interface Props {
  isOpen: boolean;
  toggle: () => void;
  header: ReactNode;
  scenarios: { scenario: ScenarioType; label: string; className?: string }[];
  ranges: RangeType;
}

const maybeFormat = (v: number, format?: (v: number) => string) => {
  return format ? format(v) : v;
};

export const ShowParametersModal = (props: Props) => {
  if (props.scenarios.length === 0) return <></>;

  const keys = Object.keys(props.scenarios[0].scenario);

  const tableBody = keys.map((k) => (
    <tr key={k}>
      <td>{props.ranges[k].title}</td>
      {props.scenarios.map((sk) => (
        <td
          key={`${k}-${sk.label}`}
          style={{ textAlign: "right" }}
          className={sk.className}
        >
          {maybeFormat(sk.scenario[k], props.ranges[k].format)}
        </td>
      ))}
    </tr>
  ));

  const body = (
    <>
      <small>This table shows the parameters used for each forecast.</small>
      <Table style={{ fontSize: "small", width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "25%" }}></th>
            {props.scenarios.map((s) => (
              <th
                key={s.label}
                className={s.className}
                style={{ width: "25%" }}
              >
                {s.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{tableBody}</tbody>
      </Table>
    </>
  );

  return (
    <ConfirmationModal
      confirmLabel="OK"
      cancelLabel=""
      {...props}
      body={body}
    />
  );
};
